export default "__VITE_ASSET__B8Au0_Ve__"